import { useState } from "react";
import Modal from "./Modal";


function CTAButton( { placeholder } ) {
    const [isOpen, setIsOpen] = useState(false);

      return (
        <>
          <button onClick={() => setIsOpen(true)}>  
              {placeholder}     
          </button>
        {isOpen && <Modal setIsOpen={setIsOpen} />}
        </>
      );
}

export default CTAButton; 